import { FDLozenge, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';

const TaxFilingLozenge = ({
  resource,
}) => {
  const taxFilingLabel = resource?.attr('currentTaxFilingLabel');
  const taxFilingStatusColor = resource?.attr('currentTaxFilingStatusColor');

  if (!taxFilingLabel) {
    return null;
  }

  return (
    <FDStack alignItems={'center'}>
      <FDLozenge color={taxFilingStatusColor ?? 'info'} label={taxFilingLabel} size={'lg'} />
    </FDStack>
  );
};

TaxFilingLozenge.defaultProps = {};

TaxFilingLozenge.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { TaxFilingLozenge };
